<div class="home-page">
  <div class="home-card">
    <h2>Overblik</h2>

    <div class="form-group image-group" *ngIf="hasEquipmentImage && equipmentImageSrc">
      <label>Udstyrsbillede</label>
      <img [src]="equipmentImageSrc"
           alt="Udstyrsbillede"
           class="equipment-image" />
    </div>

    <div class="form-group">
      <label for="id">Id</label>
      <input id="id"
             type="text"
             class="text-field"
             [ngModel]="equipment.id"
             disabled
             name="id" />
    </div>

    <div class="form-group">
      <label for="name">Navn</label>
      <input id="name"
             type="text"
             class="text-field"
             [ngModel]="equipment.name"
             disabled
             name="name" />
    </div>

    <div class="form-group">
      <label for="subcategoryName">Underkategori</label>
      <input id="subcategoryName"
             type="text"
             class="text-field"
             [ngModel]="equipment.subcategoryName"
             disabled
             name="subcategoryName" />
    </div>

    <div class="form-group">
      <label for="model">Modelnavn</label>
      <input id="model"
             type="text"
             class="text-field"
             [ngModel]="equipment.model"
             disabled
             name="model" />
    </div>

    <div class="form-group">
      <label for="isServiceOK">Kontrol</label>
      <input id="isServiceOK"
             type="text"
             class="text-field"
             [ngModel]="equipment.isServiceOKText"
             disabled
             name="isServiceOK" />
    </div>

    <div class="form-group">
      <label for="lastControlType">Kontroltype</label>
      <input id="lastControlType"
             type="text"
             class="text-field"
             [ngModel]="equipment.lastControlType"
             disabled
             name="lastControlType" />
    </div>

    <div class="form-group">
      <label for="comment">Kommentar</label>
      <input id="comment"
                class="text-field"
                [ngModel]="equipment.comment"
                disabled
                name="comment"/>
    </div>

    <div class="form-group">
      <label for="lastServiceComment">Kontrol bemærkning</label>
      <input id="lastServiceComment"
                class="text-field"
                [ngModel]="equipment.lastServiceComment"
                disabled
                name="lastServiceComment"/>
    </div>
  </div>
</div>
